module.exports = __webpack_public_path__ + "static/media/course.889e77d1.png";